// TamalePage.jsx
import React, { useState, useEffect } from "react";
import MapVisualization from "./components/MapVisualization";
import HeatmapChart from "./components/HeatmapChart";
import TimeSeriesChart from "./components/TimeSeriesChart";
import SpatialGridOverlay from "./components/SpatialGridOverlay";
import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./App.css"; // Assuming the styling is shared from App.css
const ncFiles = [
  "cdd_Sekondi_Takoradi_CHIRPS.nc",

  "r99ptot_Sekondi_Takoradi_CHIRPS.nc",

  "r30mm_Sekondi_Takoradi_CHIRPS.nc",

  "r10mm_Sekondi_Takoradi_CHIRPS.nc",

  "prcptot_Sekondi_Takoradi_CHIRPS.nc",

  "r95p_Sekondi_Takoradi_CHIRPS.nc",

  "rx5day_Sekondi_Takoradi_CHIRPS.nc",

  "r95ptot_Sekondi_Takoradi_CHIRPS.nc",

  "rx7day_Sekondi_Takoradi_CHIRPS.nc",

  "r20mm_Sekondi_Takoradi_CHIRPS.nc",

  "cwd_Sekondi_Takoradi_CHIRPS.nc",

  "r99p_Sekondi_Takoradi_CHIRPS.nc",

  "sdii_Sekondi_Takoradi_CHIRPS.nc",

  "rx1day_Sekondi_Takoradi_CHIRPS.nc",
];

const descriptions = {
  cdd: "Consecutive dry days",

  cwd: "Consecutive wet days",

  prcptot: "Annual total precipitation",

  r10mm: "Days ≥10mm",

  r20mm: "Days ≥20mm",

  r30mm: "Days ≥30mm",

  r95p: "Very wet days",

  r99p: "Extremely wet days",

  r95ptot: "Total from very wet days",

  r99ptot: "Total from extremely wet days",

  rx1day: "Max 1-day rainfall",

  rx5day: "Max 5-day rainfall",

  rx7day: "Max 7-day rainfall",

  sdii: "Simple Daily Intensity Index",
};

function TamalePage() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedVariable, setSelectedVariable] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [geojson, setBoundaryGeoJson] = useState({});
  useEffect(() => {
    const fetchBoundary = async () => {
      try {
        const geojson = {
          type: "FeatureCollection",
          name: "SekondiTakoradiMuni",
          crs: {
            type: "name",
            properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
          },
          features: [
            {
              type: "Feature",
              properties: {
                Label: "Sekondi Takoradi Metropolitan Area (STMA)",
                Region: "Western",
                District: "Sekondi Takoradi Metropolitan Area (STMA)",
              },
              geometry: {
                type: "Polygon",
                coordinates: [
                  [
                    [-1.692580348999968, 4.988057351000066],
                    [-1.689389934999951, 4.984130867000033],
                    [-1.689198198999975, 4.984213040000043],
                    [-1.688907854999968, 4.984337474000029],
                    [-1.688592032999964, 4.984472827000047],
                    [-1.688130340999976, 4.984670693000055],
                    [-1.687970391999954, 4.984104209000066],
                    [-1.687893858999928, 4.983888003000061],
                    [-1.687703810999949, 4.98335111800003],
                    [-1.687610507999977, 4.982611357000053],
                    [-1.687622826999927, 4.982085743000027],
                    [-1.68763050299998, 4.981758298000045],
                    [-1.687710476999939, 4.981345098000077],
                    [-1.687850429999969, 4.981005207000067],
                    [-1.68824363899995, 4.980305434000059],
                    [-1.688650117999941, 4.979610137000066],
                    [-1.686742913999979, 4.978096510000057],
                    [-1.685922298999969, 4.977804429000059],
                    [-1.684962598999959, 4.97794351400006],
                    [-1.684350612999935, 4.978221690000055],
                    [-1.683363093999958, 4.978764128000023],
                    [-1.681735771999968, 4.979668197000024],
                    [-1.679760734999945, 4.976163196000073],
                    [-1.679165766999972, 4.97281773800006],
                    [-1.679133647999947, 4.972637133000035],
                    [-1.678912302999947, 4.971392506000029],
                    [-1.674748931999943, 4.968586017000064],
                    [-1.674468901999944, 4.968130236000036],
                    [-1.674195772999951, 4.967388883000069],
                    [-1.674411570999951, 4.966250657000046],
                    [-1.674447877999967, 4.966038095000044],
                    [-1.674493403999975, 4.965771567000047],
                    [-1.674538745999939, 4.965506103000052],
                    [-1.674666441999932, 4.965494343000046],
                    [-1.674950290999959, 4.965222845000028],
                    [-1.675897142999929, 4.964990835000037],
                    [-1.681596274999947, 4.964646156000072],
                    [-1.684645336999949, 4.96357395900003],
                    [-1.690374887999951, 4.961798134000048],
                    [-1.694646922999937, 4.958715571000027],
                    [-1.700027109999951, 4.957080630000064],
                    [-1.701214439999944, 4.956212476000076],
                    [-1.702133665999952, 4.955510290000063],
                    [-1.702580509999962, 4.955250696000064],
                    [-1.703308227999969, 4.954603835000057],
                    [-1.703938065999978, 4.95419529000003],
                    [-1.704627484999946, 4.953420760000029],
                    [-1.705159442999957, 4.952769644000057],
                    [-1.705516918999933, 4.952041924000071],
                    [-1.705835168999954, 4.95140604300002],
                    [-1.702809500999933, 4.947089861000052],
                    [-1.702520308999965, 4.946735602000047],
                    [-1.703221600999939, 4.945806574000073],
                    [-1.705274860999964, 4.946739216000026],
                    [-1.706160507999925, 4.946562086000029],
                    [-1.706529228999955, 4.946486174000029],
                    [-1.707064232999926, 4.946327120000035],
                    [-1.707494404999977, 4.945915020000029],
                    [-1.708040253999968, 4.94513058900003],
                    [-1.708304142999964, 4.94420879200004],
                    [-1.708481272999961, 4.942950808000035],
                    [-1.706073753999931, 4.942278437000027],
                    [-1.706287029999942, 4.941674750000061],
                    [-1.707884814999943, 4.941942252000047],
                    [-1.708239074999938, 4.940951773000052],
                    [-1.708756002999962, 4.941056605000028],
                    [-1.709009045999949, 4.93991429700003],
                    [-1.708970187999967, 4.939617876000057],
                    [-1.708805709999979, 4.939041301000032],
                    [-1.708512901999939, 4.938443036000024],
                    [-1.707712202999971, 4.93822252800004],
                    [-1.706776260999959, 4.940163485000028],
                    [-1.70564741499993, 4.94001782600003],
                    [-1.705538170999944, 4.941146673000048],
                    [-1.697090025999955, 4.939872167000033],
                    [-1.694759502999943, 4.93772371700004],
                    [-1.695232888999954, 4.937286744000062],
                    [-1.697563412999955, 4.939107465000063],
                    [-1.704554981999934, 4.939799340000036],
                    [-1.704955540999947, 4.937104675000057],
                    [-1.704263666999964, 4.936813358000052],
                    [-1.704008764999969, 4.934410006000064],
                    [-1.69632532199995, 4.933463232000065],
                    [-1.692210492999948, 4.937942202000045],
                    [-1.691664276999973, 4.937468817000024],
                    [-1.694868744999951, 4.933244745000025],
                    [-1.69650739399998, 4.932662115000028],
                    [-1.709717165999962, 4.933567830000072],
                    [-1.710616880999964, 4.933285892000072],
                    [-1.711630174999925, 4.932916007000074],
                    [-1.71240877799994, 4.932694963000074],
                    [-1.714060657999937, 4.932176650000031],
                    [-1.714595739999936, 4.932006992000026],
                    [-1.715535397999929, 4.931732924000073],
                    [-1.717212423999968, 4.931250044000024],
                    [-1.717969369999935, 4.930989030000035],
                    [-1.719714910999926, 4.930333227000062],
                    [-1.720234650999942, 4.930204373000038],
                    [-1.721264589999976, 4.929899804000058],
                    [-1.723349993999932, 4.929025388000071],
                    [-1.726540013999966, 4.927706071000046],
                    [-1.72750601499996, 4.927326845000039],
                    [-1.728459203999932, 4.926435154000046],
                    [-1.729796741999962, 4.925825318000022],
                    [-1.730168280999976, 4.92581506800002],
                    [-1.730839613999933, 4.925679266000031],
                    [-1.735549186999947, 4.923631961000069],
                    [-1.736753484999952, 4.922735143000068],
                    [-1.737070109999934, 4.922424024000065],
                    [-1.737640053999939, 4.921664087000067],
                    [-1.739282510999942, 4.919322113000021],
                    [-1.739420877999976, 4.91843042000005],
                    [-1.740179328999943, 4.918097318000036],
                    [-1.741368841999929, 4.91736411100004],
                    [-1.742125258999977, 4.916567286000031],
                    [-1.742270168999937, 4.915921872000069],
                    [-1.742465504999927, 4.915446272000054],
                    [-1.743527107999967, 4.914019479000046],
                    [-1.743705102999968, 4.913029018000032],
                    [-1.743992987999945, 4.912668862000032],
                    [-1.743885662999958, 4.912662088000047],
                    [-1.744033598999977, 4.911900484000057],
                    [-1.743797994999966, 4.911221067000042],
                    [-1.743522666999979, 4.910564937000061],
                    [-1.74350622999998, 4.91049644900005],
                    [-1.743402124999932, 4.910000584000045],
                    [-1.743096660999925, 4.909488281000051],
                    [-1.742865661999929, 4.909304313000064],
                    [-1.742705790999935, 4.909204],
                    [-1.742451874999972, 4.909150710000063],
                    [-1.742429933999972, 4.908404638000036],
                    [-1.742677577999928, 4.906689929000038],
                    [-1.742489493999926, 4.906125674000066],
                    [-1.743646217999981, 4.905407816000036],
                    [-1.743680849999976, 4.905431486000055],
                    [-1.743976754999949, 4.904442656000072],
                    [-1.744064419999972, 4.904245407000076],
                    [-1.74425071099995, 4.904201575000059],
                    [-1.744650692999926, 4.904064593000044],
                    [-1.744956153999965, 4.903905700000053],
                    [-1.745147925999959, 4.903775569000061],
                    [-1.745409556999959, 4.903561882000076],
                    [-1.746121258999949, 4.902784565000047],
                    [-1.745834185999968, 4.902369411000052],
                    [-1.746589426999947, 4.899984886000027],
                    [-1.747276781999972, 4.89728638400004],
                    [-1.747346264999976, 4.894335979000061],
                    [-1.745181695999975, 4.894417661000034],
                    [-1.743915627999968, 4.890701138000054],
                    [-1.743938145999948, 4.889088106000031],
                    [-1.742029259999924, 4.887460739000062],
                    [-1.736166175999927, 4.886971269000071],
                    [-1.733092788999954, 4.888311945000055],
                    [-1.732929424999952, 4.887270503000025],
                    [-1.734672536999938, 4.881728738000049],
                    [-1.736159767999936, 4.881090960000051],
                    [-1.746613115999935, 4.880866880000042],
                    [-1.748509396999964, 4.879785046000052],
                    [-1.749546873999975, 4.879540186000042],
                    [-1.749678719999963, 4.879475182000022],
                    [-1.749826810999934, 4.879435937000039],
                    [-1.750041784999951, 4.87937897200004],
                    [-1.750352339999949, 4.879300727000043],
                    [-1.750575528999946, 4.879222580000032],
                    [-1.750793786999964, 4.87907627900006],
                    [-1.750934486999938, 4.879022569000028],
                    [-1.751031460999968, 4.878929957000025],
                    [-1.751249734999931, 4.878798262000032],
                    [-1.751535978999925, 4.878681097000026],
                    [-1.75172523699996, 4.878646806000063],
                    [-1.751924254999949, 4.878656320000061],
                    [-1.752167154999938, 4.878616244000057],
                    [-1.752380449999976, 4.878602256000022],
                    [-1.752749707999953, 4.878533908000065],
                    [-1.75280750099995, 4.878528748000065],
                    [-1.752982265999947, 4.878552896000031],
                    [-1.753123026999958, 4.878523967000035],
                    [-1.753254033999951, 4.87851364100004],
                    [-1.753351059999943, 4.878469715000051],
                    [-1.753646641999978, 4.878349613000069],
                    [-1.753778041999965, 4.878332919000059],
                    [-1.753879931999961, 4.878298725000036],
                    [-1.754447716999948, 4.878200715000048],
                    [-1.754546208999955, 4.878200011000047],
                    [-1.754695241999968, 4.878185830000064],
                    [-1.754787480999937, 4.878200334000041],
                    [-1.754962282999941, 4.878258559000074],
                    [-1.755074021999974, 4.87835093700005],
                    [-1.755433235999931, 4.878379746000064],
                    [-1.755879794999942, 4.878388980000068],
                    [-1.756151590999934, 4.878374067000038],
                    [-1.756335924999973, 4.878276490000076],
                    [-1.756403773999978, 4.878183911000065],
                    [-1.756578439999942, 4.878120422000052],
                    [-1.756767589999924, 4.877988758000072],
                    [-1.757005217999961, 4.877803486000062],
                    [-1.757194819999938, 4.877645796000024],
                    [-1.757247719999953, 4.877637683000046],
                    [-1.757344839999973, 4.877676522000058],
                    [-1.757398241999965, 4.877686198000049],
                    [-1.757558270999937, 4.877554566000072],
                    [-1.757698891999951, 4.87743269300006],
                    [-1.757805537999957, 4.877310860000023],
                    [-1.757805384999926, 4.877174540000055],
                    [-1.757727540999952, 4.877009097000041],
                    [-1.757817417999945, 4.876928170000042],
                    [-1.757913232999954, 4.876832432000072],
                    [-1.758178928999939, 4.876726983000026],
                    [-1.75830482799995, 4.876730938000037],
                    [-1.75834853899994, 4.87675523200005],
                    [-1.758479574999967, 4.876740478000045],
                    [-1.75854753699997, 4.876750137000045],
                    [-1.758615418999966, 4.876686771000038],
                    [-1.758537644999933, 4.876584620000074],
                    [-1.758503579999967, 4.87650676100003],
                    [-1.758539069999927, 4.876436383000055],
                    [-1.758707246999961, 4.876336132000063],
                    [-1.75878514599998, 4.876327708000076],
                    [-1.758857660999979, 4.876287276000028],
                    [-1.758875379999949, 4.876250316000039],
                    [-1.758920687999932, 4.876223914000036],
                    [-1.759042042999965, 4.876233512000056],
                    [-1.759114782999973, 4.876175009000065],
                    [-1.759100598999964, 4.876088180000067],
                    [-1.759134076999942, 4.876067878000072],
                    [-1.759263451999971, 4.876113076000024],
                    [-1.759425259999944, 4.876028600000041],
                    [-1.759543280999935, 4.875938360000021],
                    [-1.759692041999926, 4.875872507000054],
                    [-1.759978353999941, 4.875818627000058],
                    [-1.760051164999936, 4.875823414000024],
                    [-1.760216362999927, 4.875974152000026],
                    [-1.760357241999941, 4.876081102000057],
                    [-1.76058218299994, 4.876160004000042],
                    [-1.76065342499993, 4.876173271000027],
                    [-1.760769882999966, 4.876143926000054],
                    [-1.760911815999975, 4.876155844000039],
                    [-1.761036849999925, 4.876153360000046],
                    [-1.76113881699996, 4.876187326000036],
                    [-1.761391246999949, 4.876216253000052],
                    [-1.761527091999938, 4.876162544000067],
                    [-1.761643547999938, 4.876133200000027],
                    [-1.761730931999978, 4.87614770700003],
                    [-1.761944580999966, 4.876220493000062],
                    [-1.762085307999939, 4.876191121000033],
                    [-1.762298717999954, 4.876054561000046],
                    [-1.762429595999947, 4.875985888000059],
                    [-1.762502475999952, 4.875966696000035],
                    [-1.762575326999979, 4.876005561000056],
                    [-1.762570653999944, 4.876166229000034],
                    [-1.762473655999941, 4.87623449900002],
                    [-1.762410726999974, 4.876385496000069],
                    [-1.76246178599996, 4.876499500000023],
                    [-1.762546950999933, 4.876667717000032],
                    [-1.762770361999969, 4.876789177000035],
                    [-1.763061711999967, 4.876900825000064],
                    [-1.763241383999969, 4.876973648000046],
                    [-1.763319562999925, 4.876971125000068],
                    [-1.763532620999968, 4.87698305300006],
                    [-1.763906344999953, 4.876968025000053],
                    [-1.764241208999977, 4.87692869600005],
                    [-1.764479027999926, 4.876913819000038],
                    [-1.764685023999959, 4.876885554000069],
                    [-1.764842972999929, 4.876835508000056],
                    [-1.76507589299996, 4.87678169000003],
                    [-1.765305501999933, 4.876681478000023],
                    [-1.765502752999964, 4.876542645000029],
                    [-1.765631862999953, 4.876352220000058],
                    [-1.765648066999972, 4.876279578000037],
                    [-1.765655313999957, 4.876154462000045],
                    [-1.765662418999966, 4.876094556000055],
                    [-1.765730305999966, 4.876036056000032],
                    [-1.765793409999958, 4.876040852000074],
                    [-1.766056010999932, 4.875798020000047],
                    [-1.766072058999953, 4.875651050000045],
                    [-1.765977561999932, 4.875567022000041],
                    [-1.765895966999949, 4.875523452000039],
                    [-1.765865512999937, 4.875420030000043],
                    [-1.765883659999929, 4.875371324000071],
                    [-1.766011007999964, 4.875316407000071],
                    [-1.766229219999957, 4.875133589000029],
                    [-1.766459622999946, 4.874999440000067],
                    [-1.766623399999958, 4.874968826000043],
                    [-1.766744647999928, 4.874883487000034],
                    [-1.766914431999965, 4.874798096000063],
                    [-1.767066083999964, 4.874773579000021],
                    [-1.767351281999936, 4.874809767000045],
                    [-1.767600112999958, 4.874876426000071],
                    [-1.767806582999981, 4.875040503000037],
                    [-1.767664726999953, 4.875194786000066],
                    [-1.76765516699993, 4.875271933000022],
                    [-1.767798386999971, 4.875302939000051],
                    [-1.767813002999958, 4.875350867000066],
                    [-1.767681765999953, 4.875472631000036],
                    [-1.767679760999954, 4.875557933000039],
                    [-1.767758901999969, 4.875795184000026],
                    [-1.767869152999936, 4.875948946000051],
                    [-1.768044979999956, 4.876054522000061],
                    [-1.768238562999954, 4.876105006000046],
                    [-1.768457325999975, 4.876131903000044],
                    [-1.768724096999961, 4.876244420000035],
                    [-1.769660156999976, 4.876276799000038],
                    [-1.77009, 4.876574740000024],
                    [-1.77031246699994, 4.876728939000031],
                    [-1.770667398999933, 4.876929840000059],
                    [-1.770965617999934, 4.877187949000074],
                    [-1.771239678999962, 4.877446081000073],
                    [-1.771513723999931, 4.87768806400004],
                    [-1.771836041999961, 4.877897683000072],
                    [-1.771892488999924, 4.877970306000066],
                    [-1.771950008999966, 4.878048111000055],
                    [-1.772021708999944, 4.878309373000036],
                    [-1.772062180999967, 4.878495084000065],
                    [-1.77209453599994, 4.878624272000025],
                    [-1.772231529999942, 4.878721034000023],
                    [-1.772301683999956, 4.878739028000041],
                    [-1.772400733999973, 4.878817756000046],
                    [-1.772392654999976, 4.87890507700007],
                    [-1.772272373999954, 4.879229805000023],
                    [-1.77219204499994, 4.879399507000073],
                    [-1.772208199999966, 4.879618157000039],
                    [-1.772153335999974, 4.879783881000037],
                    [-1.772112105999952, 4.87990841900006],
                    [-1.772112337999943, 4.880110332000072],
                    [-1.772188674999938, 4.88022340200007],
                    [-1.772193032999951, 4.880263691000039],
                    [-1.772752040999933, 4.880243022000059],
                    [-1.772869373999924, 4.880238685000052],
                    [-1.773900114999947, 4.880310186000031],
                    [-1.774198196999976, 4.880447143000026],
                    [-1.774420028999941, 4.88052245800003],
                    [-1.77456875699994, 4.880592094000065],
                    [-1.774721799999952, 4.880640376000031],
                    [-1.77484263499997, 4.88068869500006],
                    [-1.774926027999925, 4.880701275000035],
                    [-1.775051877999942, 4.880591535000065],
                    [-1.775059752999937, 4.88043807300005],
                    [-1.775019381999925, 4.880341200000032],
                    [-1.775224949999938, 4.880150642000046],
                    [-1.775405657999954, 4.880146920000072],
                    [-1.775601802999972, 4.880124145000025],
                    [-1.775856568999927, 4.880146400000058],
                    [-1.776331728999935, 4.880226615000026],
                    [-1.77663777999993, 4.880290873000035],
                    [-1.776863449999951, 4.880476374000068],
                    [-1.777040472999943, 4.880371173000071],
                    [-1.776863059999926, 4.880137160000061],
                    [-1.776792651999926, 4.880077924000034],
                    [-1.776830676999964, 4.879983744000072],
                    [-1.776895267999976, 4.879919252000036],
                    [-1.776983634999965, 4.879959337000059],
                    [-1.777393663999931, 4.880138453000029],
                    [-1.77761210999995, 4.880322054000032],
                    [-1.77851988499998, 4.881196505000048],
                    [-1.778627927999935, 4.881419279000056],
                    [-1.778878090999967, 4.88189550200002],
                    [-1.779055708999977, 4.882307199000024],
                    [-1.779281584999978, 4.882670379000047],
                    [-1.779434929999979, 4.882977108000034],
                    [-1.779814110999951, 4.883614712000053],
                    [-1.779935664999925, 4.884284921000074],
                    [-1.779935852999927, 4.884446450000041],
                    [-1.779872144999956, 4.885060337000027],
                    [-1.779856731999928, 4.885222046000024],
                    [-1.779848276999928, 4.885310735000076],
                    [-1.779897392999942, 4.886005258000068],
                    [-1.779972006999969, 4.88610591500003],
                    [-1.780139578999979, 4.886546101000022],
                    [-1.78055896199993, 4.887127123000027],
                    [-1.780696069999976, 4.887320797000029],
                    [-1.781083337999974, 4.887982620000059],
                    [-1.78130121099997, 4.888386192000041],
                    [-1.781494732999931, 4.888620184000047],
                    [-1.781535579999968, 4.888711113000056],
                    [-1.781672158999925, 4.88886227100005],
                    [-1.782010729999968, 4.889193012000021],
                    [-1.782098272999974, 4.889252642000031],
                    [-1.782141825999929, 4.889282309000066],
                    [-1.782590848999973, 4.889507321000053],
                    [-1.782760034999967, 4.889587886000072],
                    [-1.783162949999962, 4.889853939000034],
                    [-1.783759209999971, 4.890200532000051],
                    [-1.784178218999955, 4.890458491000061],
                    [-1.784540866999976, 4.890716514000076],
                    [-1.784653866999975, 4.890950599000064],
                    [-1.784784362999972, 4.891082243000028],
                    [-1.785610489999954, 4.89318593400003],
                    [-1.786351340999943, 4.895072473000027],
                    [-1.787096297999938, 4.895175228000028],
                    [-1.787627187999931, 4.895277981000049],
                    [-1.78802963499993, 4.895569112000032],
                    [-1.788055324999959, 4.895980124000062],
                    [-1.787875506999967, 4.896433948000038],
                    [-1.787618623999947, 4.89675077000004],
                    [-1.787293242999965, 4.896810708000032],
                    [-1.786856542999942, 4.897041901000023],
                    [-1.786445531999959, 4.897529976000044],
                    [-1.786428404999924, 4.897949550000021],
                    [-1.78652259699993, 4.898283497000023],
                    [-1.786710974999949, 4.89837768700005],
                    [-1.787074454999924, 4.898267344000033],
                    [-1.787190486999975, 4.898232121000035],
                    [-1.787695689999964, 4.898548942000048],
                    [-1.787875504999931, 4.898857199000076],
                    [-1.787817081999947, 4.899193143000048],
                    [-1.787807004999934, 4.89925108500006],
                    [-1.78766143799993, 4.899405214000069],
                    [-1.787490183999978, 4.899448027000062],
                    [-1.786685285999965, 4.900107358000071],
                    [-1.786663232999956, 4.900168921000045],
                    [-1.786479780999969, 4.900681062000046],
                    [-1.786599659999979, 4.901554457000032],
                    [-1.785228234999977, 4.901614878000032],
                    [-1.785228234999977, 4.901738555000065],
                    [-1.782000291999964, 4.901812759000052],
                    [-1.781790040999965, 4.903136093000057],
                    [-1.781871268999964, 4.906358142000045],
                    [-1.781901347999963, 4.907551323000064],
                    [-1.781895343999963, 4.90756224200004],
                    [-1.781629260999978, 4.908046026000022],
                    [-1.780936674999964, 4.908911760000024],
                    [-1.780639853999958, 4.910037210000041],
                    [-1.780245589999936, 4.909791068000061],
                    [-1.779527523999946, 4.909342772000059],
                    [-1.778721124999947, 4.908839328000056],
                    [-1.778159408999954, 4.908488646000023],
                    [-1.777454355999964, 4.908048473000065],
                    [-1.776162782999961, 4.907242132000022],
                    [-1.775605534999954, 4.906930656000043],
                    [-1.773933531999944, 4.905996088000052],
                    [-1.772029504999978, 4.90493182900002],
                    [-1.771952786999975, 4.904888946000028],
                    [-1.770498424999971, 4.90407602800002],
                    [-1.76826607199996, 4.902864003000047],
                    [-1.768097529999977, 4.902746175000061],
                    [-1.768052505999947, 4.902725362000069],
                    [-1.768012129999931, 4.902706698000031],
                    [-1.767934631999935, 4.902828105000026],
                    [-1.767834090999941, 4.902827770000044],
                    [-1.765399872999978, 4.902748667000026],
                    [-1.76462502399994, 4.902723497000068],
                    [-1.76385017299998, 4.902698327000053],
                    [-1.763305672999934, 4.90267092800002],
                    [-1.762480296999968, 4.902640360000021],
                    [-1.761147470999958, 4.902591448000067],
                    [-1.759698477999962, 4.90253948000003],
                    [-1.757772602999978, 4.902466111000024],
                    [-1.757498181999949, 4.902456237000024],
                    [-1.753694641999971, 4.902319378000072],
                    [-1.753691582999977, 4.90227046900003],
                    [-1.753688526999952, 4.902221556000029],
                    [-1.753651842999943, 4.902154303000032],
                    [-1.75363961599993, 4.902142076000075],
                    [-1.753602933999957, 4.902096221000022],
                    [-1.753498995999962, 4.902047311000047],
                    [-1.753364491999946, 4.902053425000076],
                    [-1.75326055499994, 4.902096221000022],
                    [-1.753242338999939, 4.902131808000036],
                    [-1.753174452999929, 4.902229396000052],
                    [-1.75317445099995, 4.902352441000062],
                    [-1.753182936999963, 4.902407598000025],
                    [-1.753210515999967, 4.902471242000047],
                    [-1.753252945999975, 4.902522159000057],
                    [-1.753337803999955, 4.902564588000075],
                    [-1.753295373999947, 4.903387716000054],
                    [-1.753300027999956, 4.903429366000069],
                    [-1.753397228999972, 4.904299795000043],
                    [-1.753455670999926, 4.905677412000045],
                    [-1.753465091999942, 4.905899529000067],
                    [-1.75341866499997, 4.906601084000044],
                    [-1.753312346999962, 4.908207680000032],
                    [-1.753298615999938, 4.908334255000057],
                    [-1.75327866899994, 4.908518146000063],
                    [-1.753213277999976, 4.909120956000038],
                    [-1.753182682999977, 4.909403009000073],
                    [-1.753095835999943, 4.910203650000028],
                    [-1.753040797999972, 4.910711010000057],
                    [-1.752421330999937, 4.912476065000021],
                    [-1.751575776999971, 4.914631476000068],
                    [-1.751045155999975, 4.915991536000035],
                    [-1.75079887399994, 4.916617271000064],
                    [-1.750198164999972, 4.918143522000037],
                    [-1.750072209999928, 4.918463538000026],
                    [-1.749528932999965, 4.91983602800002],
                    [-1.749387544999934, 4.920193218000065],
                    [-1.749165263999942, 4.920479395000029],
                    [-1.749092879999978, 4.920554367000022],
                    [-1.749011964999966, 4.920638173000043],
                    [-1.748814863999939, 4.92078052100004],
                    [-1.748729615999935, 4.920823144000053],
                    [-1.748616394999942, 4.920899505000023],
                    [-1.74847975199998, 4.920955287000027],
                    [-1.748343256999931, 4.921011011000076],
                    [-1.748059310999963, 4.921059747000072],
                    [-1.747506335999958, 4.921180198000059],
                    [-1.747407916999975, 4.921205401000066],
                    [-1.747057383999959, 4.921295172000043],
                    [-1.746537257999933, 4.92153059900005],
                    [-1.745578492999925, 4.922094578000042],
                    [-1.74532727999997, 4.922242349000044],
                    [-1.745238309999934, 4.922286149000058],
                    [-1.745376175999979, 4.922516505000033],
                    [-1.745480577999956, 4.922658450000029],
                    [-1.745765277999965, 4.923101927000062],
                    [-1.746066405999954, 4.923649428000033],
                    [-1.746169174999977, 4.92391082000006],
                    [-1.746318255999938, 4.924290007000025],
                    [-1.746336060999965, 4.924401780000039],
                    [-1.746416806999946, 4.924908683000069],
                    [-1.746396661999938, 4.925147318000029],
                    [-1.746345629999951, 4.925751836000074],
                    [-1.746154004999937, 4.926419788000032],
                    [-1.746104943999967, 4.926517911000076],
                    [-1.745913102999964, 4.926901587000032],
                    [-1.745754327999975, 4.927158915000064],
                    [-1.745702983999934, 4.927215309000076],
                    [-1.745619868999938, 4.927306600000065],
                    [-1.74624664199996, 4.92795476200007],
                    [-1.746324052999967, 4.928025724000065],
                    [-1.746816918999968, 4.928477516000044],
                    [-1.746926444999929, 4.928627277000032],
                    [-1.747149580999974, 4.928932381000038],
                    [-1.747263324999949, 4.929195977000063],
                    [-1.747824203999926, 4.930327613000031],
                    [-1.748860414999967, 4.932897168000068],
                    [-1.749091241999963, 4.933426713000074],
                    [-1.749417114999972, 4.93406488200003],
                    [-1.74973135099998, 4.934518777000051],
                    [-1.74978372299995, 4.934594423000021],
                    [-1.750163905999955, 4.93504249800003],
                    [-1.750434347999942, 4.935305825000057],
                    [-1.750679871999978, 4.935544886000059],
                    [-1.75114152499998, 4.935925072000032],
                    [-1.751496969999948, 4.93620141100007],
                    [-1.751810640999963, 4.93647157700002],
                    [-1.752403906999973, 4.93698256700003],
                    [-1.752848268999969, 4.937354737000021],
                    [-1.753083980999975, 4.937568325000029],
                    [-1.753297217999943, 4.937751988000059],
                    [-1.753350687999955, 4.937810766000041],
                    [-1.753638637999927, 4.938098915000069],
                    [-1.754035086999977, 4.93843971900003],
                    [-1.754065441999956, 4.938467666000065],
                    [-1.75409579799998, 4.938495614000033],
                    [-1.754842327999938, 4.939182912000035],
                    [-1.755440403999955, 4.938204616000064],
                    [-1.755592576999959, 4.937955703000057],
                    [-1.755876305999948, 4.937492366000072],
                    [-1.756097952999937, 4.937130410000066],
                    [-1.756157963999954, 4.937047896000024],
                    [-1.756394688999933, 4.936722400000065],
                    [-1.756443532999924, 4.936673555000027],
                    [-1.756714605999946, 4.936402482000062],
                    [-1.757003696999959, 4.936174422000022],
                    [-1.757131888999936, 4.93607329200006],
                    [-1.757410077999964, 4.935901742000055],
                    [-1.757549427999948, 4.935833209000066],
                    [-1.757692904999942, 4.935762649000026],
                    [-1.757994275999977, 4.935651372000052],
                    [-1.758306772999958, 4.93553109800007],
                    [-1.759331843999973, 4.935142670000062],
                    [-1.759589223999967, 4.935748738000029],
                    [-1.760108511999931, 4.936583305000056],
                    [-1.760372787999927, 4.936884678000069],
                    [-1.761029484999938, 4.937622083000065],
                    [-1.761202719999972, 4.937816609000038],
                    [-1.761689550999961, 4.938391533000072],
                    [-1.762102754999944, 4.938986830000033],
                    [-1.762236654999924, 4.939179734000049],
                    [-1.762635390999947, 4.939773204000062],
                    [-1.762803464999934, 4.939989960000048],
                    [-1.763025439999979, 4.940284252000026],
                    [-1.763369114999932, 4.940699341000027],
                    [-1.763874491999957, 4.941422633000059],
                    [-1.764199044999941, 4.941992920000075],
                    [-1.76427786499994, 4.942618844000037],
                    [-1.76466269499997, 4.94306858300007],
                    [-1.765251526999975, 4.943671325000025],
                    [-1.765854268999931, 4.944274069000073],
                    [-1.766024049999942, 4.944055479000042],
                    [-1.766365548999943, 4.943785272000071],
                    [-1.766655223999976, 4.94355607600005],
                    [-1.767016773999956, 4.943363951000038],
                    [-1.76723519799998, 4.943247882000037],
                    [-1.767397389999928, 4.943572284000027],
                    [-1.767433902999926, 4.943712006000055],
                    [-1.767505746999973, 4.943986912000071],
                    [-1.767476042999931, 4.944212323000045],
                    [-1.767434449999939, 4.944527976000074],
                    [-1.767469779999942, 4.944834085000025],
                    [-1.767702299999939, 4.945067512000037],
                    [-1.767919441999936, 4.945285506000062],
                    [-1.767963074999955, 4.945358250000027],
                    [-1.768025694999949, 4.945462650000024],
                    [-1.768108436999967, 4.945687095000039],
                    [-1.767874691999964, 4.946051847000035],
                    [-1.767793378999954, 4.946102293000024],
                    [-1.768167381999945, 4.946335459000068],
                    [-1.768195162999973, 4.946487710000042],
                    [-1.768266273999927, 4.946558864000053],
                    [-1.768319534999932, 4.946612157000061],
                    [-1.768334288999938, 4.947231726000041],
                    [-1.768351646999974, 4.947836580000057],
                    [-1.768417718999956, 4.947968729000024],
                    [-1.768304201999968, 4.948401557000068],
                    [-1.768045688999962, 4.948536753000042],
                    [-1.768043898999963, 4.948879469000076],
                    [-1.767943005999939, 4.949007583000025],
                    [-1.767885992999936, 4.949079975000075],
                    [-1.767744049999976, 4.949357994000025],
                    [-1.767561566999973, 4.949563453000053],
                    [-1.767370151999955, 4.949778967000043],
                    [-1.76784138599993, 4.950403679000033],
                    [-1.767970079999941, 4.950574288000041],
                    [-1.768049861999941, 4.950651457000049],
                    [-1.768644719999941, 4.95122684100005],
                    [-1.768126120999966, 4.953342961000033],
                    [-1.768006445999958, 4.953768454000055],
                    [-1.76766721599995, 4.95415672300004],
                    [-1.767367701999945, 4.95414955900003],
                    [-1.767000881999934, 4.954217571000072],
                    [-1.766511138999931, 4.95420019200003],
                    [-1.76631101199996, 4.954196706000062],
                    [-1.766169373999958, 4.954187514000068],
                    [-1.76616943099998, 4.954236448000074],
                    [-1.766113699999948, 4.95426447400007],
                    [-1.766085855999961, 4.954295966000075],
                    [-1.765866335999931, 4.954334669000048],
                    [-1.765706030999979, 4.954345338000053],
                    [-1.765594524999926, 4.954362945000071],
                    [-1.765423797999972, 4.954401591000021],
                    [-1.765277457999957, 4.954433218000077],
                    [-1.765139089999934, 4.954393156000037],
                    [-1.765186489999962, 4.954515609000055],
                    [-1.765185548999966, 4.954615473000047],
                    [-1.76518035099997, 4.955166517000066],
                    [-1.76519546399993, 4.955228312000031],
                    [-1.765214583999978, 4.955306496000048],
                    [-1.765273884999942, 4.955548967000027],
                    [-1.765333029999965, 4.955790811000043],
                    [-1.765456679999943, 4.956296396000027],
                    [-1.765601516999936, 4.956995756000026],
                    [-1.765716707999957, 4.957406538000043],
                    [-1.76580906099997, 4.95783250300002],
                    [-1.766183939999962, 4.958571891000076],
                    [-1.766454468999939, 4.958915440000055],
                    [-1.76670435099993, 4.959240458000068],
                    [-1.766766626999924, 4.959321459000023],
                    [-1.767159258999925, 4.959478444000069],
                    [-1.76723438099998, 4.959508479000021],
                    [-1.767795579999927, 4.959643289000041],
                    [-1.768284051999956, 4.959778180000058],
                    [-1.768637445999957, 4.959902810000074],
                    [-1.76879710399993, 4.960043096000049],
                    [-1.768866333999938, 4.960173466000072],
                    [-1.769110072999979, 4.960718451000048],
                    [-1.769596, 4.961962095000047],
                    [-1.769736013999932, 4.962308009000026],
                    [-1.769933679999951, 4.962670397000068],
                    [-1.770073690999936, 4.96291747600003],
                    [-1.770279591999952, 4.963123377000045],
                    [-1.770897297999966, 4.963609304000045],
                    [-1.771391459999961, 4.963930512000047],
                    [-1.771795026999939, 4.964161119000039],
                    [-1.771992692999959, 4.964325842000051],
                    [-1.772289187999945, 4.964597631000061],
                    [-1.772412586999963, 4.964721031000067],
                    [-1.772478619999958, 4.964787061000038],
                    [-1.772635104999949, 4.965058849000059],
                    [-1.771259681999936, 4.965454180000052],
                    [-1.769744247999938, 4.965783621000071],
                    [-1.767668762999961, 4.965487125000038],
                    [-1.764110789999961, 4.964235243000076],
                    [-1.762282386999971, 4.962588033000031],
                    [-1.761211698999944, 4.961418514000059],
                    [-1.759109345999946, 4.957227235000062],
                    [-1.758096272999978, 4.958305216000042],
                    [-1.756760966999934, 4.959172237000075],
                    [-1.756190679999975, 4.959492156000067],
                    [-1.755467387999943, 4.95984452600004],
                    [-1.755212382999957, 4.959951165000064],
                    [-1.758166206999931, 4.962707],
                    [-1.758275101999971, 4.964776004000043],
                    [-1.756700312999953, 4.966970655000068],
                    [-1.755820774999961, 4.968151746000046],
                    [-1.756314989999964, 4.972658323000076],
                    [-1.756541155999969, 4.974744079000061],
                    [-1.756608167999957, 4.975179659000048],
                    [-1.755799833999959, 4.976029878000077],
                    [-1.755473147999965, 4.975728322000066],
                    [-1.755401946999939, 4.97555660300003],
                    [-1.755079450999972, 4.974961870000072],
                    [-1.754911918999937, 4.974413206000065],
                    [-1.754601989999969, 4.973931555000036],
                    [-1.754447021999965, 4.973479222000037],
                    [-1.754350692999935, 4.973031078000076],
                    [-1.754116149999959, 4.972641569000075],
                    [-1.753873228999964, 4.972021705000031],
                    [-1.753144472999963, 4.970459481000034],
                    [-1.752930868999954, 4.97023331500003],
                    [-1.752440840999952, 4.96986055900004],
                    [-1.751980131999971, 4.969600886000023],
                    [-1.751829355999973, 4.969441732000064],
                    [-1.751791659999981, 4.969278390000056],
                    [-1.749479736999945, 4.969931759000076],
                    [-1.749217963999968, 4.969808143000023],
                    [-1.748575070999948, 4.96950455700005],
                    [-1.746030406999978, 4.968307997000068],
                    [-1.745918974999938, 4.968464229000062],
                    [-1.741773131999935, 4.970591889000048],
                    [-1.736242724999954, 4.974987296000052],
                    [-1.733475794999947, 4.980044876000022],
                    [-1.733688973999961, 4.981253915000025],
                    [-1.733984901999975, 4.981648487000029],
                    [-1.734206847999928, 4.98242940800003],
                    [-1.73437125199996, 4.983333633000029],
                    [-1.734190405999925, 4.984040573000073],
                    [-1.733606770999927, 4.984706410000058],
                    [-1.733734598999945, 4.984833811000044],
                    [-1.734166094999978, 4.990506779000043],
                    [-1.735016210999959, 4.991180175000068],
                    [-1.735320205999926, 4.991982277000034],
                    [-1.735194858999932, 4.992706127000076],
                    [-1.734676270999955, 4.993407217000026],
                    [-1.737217259999966, 4.997317806000069],
                    [-1.737327833999927, 5.00125728200004],
                    [-1.735276793999958, 5.002714753000021],
                    [-1.73337014599997, 5.003139144000045],
                    [-1.732552363999957, 5.003321166000035],
                    [-1.728413898999975, 5.005384312000047],
                    [-1.72487525899993, 5.00581414100003],
                    [-1.720983787999955, 5.007238114000074],
                    [-1.713419490999968, 5.00541477400003],
                    [-1.708476818999941, 5.003373690000046],
                    [-1.705035830999975, 4.999499918000026],
                    [-1.704735551999931, 4.999400931000025],
                    [-1.699825062999935, 4.99778217100004],
                    [-1.699065210999947, 4.996840429000031],
                    [-1.697026452999978, 4.994313615000067],
                    [-1.693964088999962, 4.990518099000042],
                    [-1.694163762999949, 4.990433875000065],
                    [-1.69358, 4.989771784000027],
                    [-1.693131498999946, 4.989263100000073],
                    [-1.692937270999948, 4.988838190000024],
                    [-1.692580348999968, 4.988057351000066],
                  ],
                ],
              },
            },
          ],
        };

        setBoundaryGeoJson(geojson);
      } catch (err) {
        console.error("Failed to load GeoJSON boundary", err);
      }
    };
    fetchBoundary();
  }, []);
  const handleVisualize = async (file) => {
    // The API endpoint is updated for the Tamale dataset
    const url = `https://ghclimatevulnerabilityhub.com/dataset/Sekondi-Takoradi/${file}`;
    setSelectedFile(file);
    setLoading(true);
    setResponse(null);
    setSelectedLocation(null);

    try {
      const res = await fetch(
        `https://climate.misconm.org/api/load?url=${encodeURIComponent(url)}`
      );
      const json = await res.json();

      if (json.error) {
        alert("Error loading data: " + json.error);
        return;
      }

      const validVariables = json.variables.filter(
        (v) => !["time", "latitude", "longitude", "spatial_ref"].includes(v)
      );

      if (validVariables.length === 0) {
        alert("No valid visualizable variable found in this dataset.");
        return;
      }

      setResponse(json);
      setSelectedVariable(validVariables[0]);
    } catch (err) {
      console.error("Failed to load file", err);
      alert("Failed to load file.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tamale-page-container">
      <header className="page-header">
        <h1 className="page-title">Sekondi Takoradi Dataset Viewer</h1>
      </header>

      <main className="page-content">
        <section className="file-list-section">
          <h2 className="section-title">📁 Available Datasets</h2>
          <div className="file-list-grid">
            {ncFiles.map((file) => {
              const key = file.split("_")[0];
              const isSelected = selectedFile === file;
              return (
                <div
                  key={file}
                  className={`file-card ${isSelected ? "selected" : ""}`}
                >
                  <div className="file-info">
                    <p className="file-name">{file}</p>
                    <p className="file-description">
                      {descriptions[key] || "No description"}
                    </p>
                  </div>
                  <button
                    className="visualize-button"
                    onClick={() => handleVisualize(file)}
                    disabled={loading && isSelected}
                  >
                    {loading && isSelected ? "Loading..." : "Visualize"}
                  </button>
                </div>
              );
            })}
          </div>
        </section>

        {loading && (
          <div className="loading-message-container">
            <div className="spinner"></div>
            <p>Loading dataset...</p>
          </div>
        )}

        {response && selectedVariable && (
          <section className="visualization-section">
            <div className="visualization-grid">
              <div className="chart-container">
                <h3 className="chart-title">🗺 Map Visualization</h3>
                <MapVisualization
                  response={response}
                  selectedVariable={selectedVariable}
                  onLocationSelect={(loc) => setSelectedLocation(loc)}
                  boundaryGeoJson={geojson}
                />
              </div>

              <div className="chart-container">
                <h3 className="chart-title">🟦 Spatial Grid Preview</h3>
                <div style={{ padding: "20px", width: "100%", height: "100%" }}>
                  <SpatialGridOverlay
                    response={response}
                    selectedVariable={selectedVariable}
                  />
                </div>
              </div>
            </div>

            {selectedLocation && response.coords.time?.length > 0 && (
              <div className="chart-container time-series-container">
                <h3 className="chart-title">
                  📈 Time Series at ({selectedLocation.lat.toFixed(2)}°N,{" "}
                  {selectedLocation.lon.toFixed(2)}°E)
                </h3>
                <TimeSeriesChart
                  data={{
                    variables: {
                      [selectedVariable]: {
                        data: response.data[selectedVariable],
                      },
                      latitude: { data: response.coords.latitude },
                      longitude: { data: response.coords.longitude },
                      time: { data: response.coords.time },
                    },
                  }}
                  location={selectedLocation}
                  variable={selectedVariable}
                />
              </div>
            )}
          </section>
        )}
      </main>
    </div>
  );
}

export default TamalePage;
